<mat-expansion-panel hideToggle #panel="matExpansionPanel" (opened)="panelOpenState = true" (closed)="panelOpenState = false" [expanded]="forceOpen">
  <mat-expansion-panel-header expandedHeight="47px" collapsedHeight="47px">
    <mat-panel-title>
      <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="2px"><strong>{{title}}&nbsp;</strong> <small class="text-info">{{ subtitle }}</small> <mat-icon *ngIf="info" [matTooltip]="info" color="accent">info</mat-icon> </span>
    </mat-panel-title>
    <mat-icon *ngIf="!panelOpenState">add</mat-icon>
    <mat-icon *ngIf="panelOpenState">remove</mat-icon>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
  <!-- {{color}} -->
</mat-expansion-panel>
